// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressHomeDeliveryView_container__9HkSK","selectExistingAddressButton":"AddressHomeDeliveryView_selectExistingAddressButton__vRQsk"};